// IMPORTS
// OHS
import OHSWidget from '../../../../../onehivesystems/js/OHSWidget';
import { OHSListDataFormatter } from '../../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormSubmitListener, OHSFormDataExtractor, OHSFormDataClearer } from '../../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';
// Assets
import Fields from '../../Device/Modules/Fields';
import { portTemplateModel } from './../_variables';


// COMPONENT
export default function PortTemplate (props) {
   // Functions
   const updatePortTemplate = function () {
      OHSCRUD({
         url: '/v1/oneport/porttemplates/' + props.content.id.value,
         method: 'PUT',
         payload: buildPayload(),
         success: function (data) {
            var temp = props.parent.portTemplates;
            temp[props.index] = OHSListDataFormatter(data[0], portTemplateModel);
            props.parent.setPortTemplates(temp);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const deletePortTemplate = function () {
      OHSCRUD({
         url: '/v1/oneport/porttemplates/' + props.content.id.value,
         method: 'DELETE',
         success: function () {
            props.hidePopup(props.index);
            var temp = props.parent.portTemplates;
            temp.splice(props.index, 1);
            props.parent.setPortTemplates(temp);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to delete this port template?",
         showSuccessPopup: true
      });
   }
   const buildPayload = function () {
      var master = {};
      var baseinfo = JSON.parse(OHSFormDataExtractor('oneport-porttemplate-baseinfo'));
      master['name'] = baseinfo.name;
      master['fields'] = JSON.parse(OHSFormDataExtractor('oneport-porttemplate-fields'));;
      return JSON.stringify(master);
   }

   // Component
   return (
      <div id='oneport-porttemplate' className='oneport-porttemplate' onKeyDown={(e) => {OHSFormSubmitListener(e, updatePortTemplate);}}>
         <div id='oneport-porttemplate-baseinfo' className='oneport-porttemplate-baseinfo'>
            <OHSFormItem onehive={props.onehive} title="Template Name">
               <input type='text' className='ohsinput' defaultValue={props.content.name.value} data-ohsformdata='name' />
            </OHSFormItem>
         </div>
         <OHSWidget onehive={props.onehive} id='oneport-porttemplate-fields' title="Fields">
            {props.parent.fields && props.parent.fields.length > 0 && props.parent.fields.map(function (field, i) {
               return (
                  <OHSFormItem key={`oneport-porttemplate-${props.index}-field-${i}`} onehive={props.onehive} title={field.name}>
                     <Fields onehive={props.onehive} parent={{
                        type: field.type,
                        defaultvalue: props.content[field.id].value,
                        disabled: false,
                        ohsformdata: field.id,
                        selectContent: field.options && field.options.split("\n"),
                        selectSimple: true,
                        selectBlank: true
                     }} />
                  </OHSFormItem>
               );
            })}
         </OHSWidget>
         <OHSFormSubmit onehive={props.onehive} update={updatePortTemplate} clear={() => {OHSFormDataClearer('oneport-porttemplate');}} delete={deletePortTemplate} keyListener={true} />
      </div>
   );
}